enum PostMessageEventName {
  Logout = 'logout',
  OpenDeviceSettings = 'openDeviceSettings',
  TriggerAppTrackingTransparencyDialog = 'triggerAppTrackingTransparencyDialog',
  ShareUrl = 'shareUrl',
  TriggerRatingDialog = 'triggerRatingDialog',
  SetUserId = 'setUserId',
  GetNativeNotificationPermission = 'getNativeNotificationPermission',
  ShowNativeNotificationPermissionDialog = 'showNativeNotificationPermissionDialog',
  GetDeviceToken = 'getDeviceToken',
  GetDeviceInfo = 'getDeviceInfo',
  HydrationFinished = 'hydrationFinished',
}

export default PostMessageEventName;
